import {Button, Statistic} from 'antd';
import {useEffect, useRef} from 'react';
import {useRouter} from 'next/router';
import useCommon from '@utils/hooks/common';
import styles from './styles';
import {AnimatePresence, motion} from 'framer-motion';
import {CHIP_FADING_DURATION, CHIP_TRANSITION_DURATION} from '@constant/game';
// import Poker from '@components/Poker';
// import classnames from 'classnames';

interface ChipsImageInterface {
  chipAmount: number;
}

const ChipsImage = (props: ChipsImageInterface): JSX.Element => {
  const {classes} = useCommon({
    withStyles: styles,
  });

  const {chipAmount} = props;

  enum ChipColor {
    BLACK = 'black',
    GREEN = 'green',
    BLUE = 'blue',
    RED = 'red',
    YELLOW = 'yellow',
  }
  // TODO change chips images
  const getNumberOfChips = (amount: number): {color: string; amount: number; imgPath: string}[] => {
    const numberOfChips = [
      {
        color: ChipColor.BLACK,
        amount: 0,
        imgPath: '/images-mobile/game-room/Player/chips_phase_2.1/black_chip.webp',
      },
      {
        color: ChipColor.GREEN,
        amount: 0,
        imgPath: '/images-mobile/game-room/Player/chips_phase_2.1/green_chip.webp',
      },
      {
        color: ChipColor.BLUE,
        amount: 0,
        imgPath: '/images-mobile/game-room/Player/chips_phase_2.1/blue_chip.webp',
      },
      {
        color: ChipColor.RED,
        amount: 0,
        imgPath: '/images-mobile/game-room/Player/chips_phase_2.1/red_chip.webp',
      },
      {
        color: ChipColor.YELLOW,
        amount: 0,
        imgPath: '/images-mobile/game-room/Player/chips_phase_2.1/yellow_chip.webp',
      },
    ];
    const [unitOfBlackChips, unitOfGreenChips, unitOfBlueChips, unitOfRedChips, unitOfYellowChips] =
      [100, 25, 10, 5, 1];

    const blackRemain = amount % unitOfBlackChips;
    let numberOfBlackChip = Math.floor(amount / unitOfBlackChips);

    // display black chips at a maximum of 5
    if (numberOfBlackChip > 5) {
      numberOfBlackChip = 5;
      amount -= 5 * unitOfBlackChips;
    } else {
      amount -= numberOfBlackChip * unitOfBlackChips;
    }

    const greenRemain = blackRemain % unitOfGreenChips;
    const numberOfGreenChip = Math.floor(blackRemain / unitOfGreenChips);

    const blueRemain = greenRemain % unitOfBlueChips;
    const numberOfBlueChip = Math.floor(greenRemain / unitOfBlueChips);

    const redRemain = blueRemain % unitOfRedChips;
    const numberOfRedChip = Math.floor(blueRemain / unitOfRedChips);

    const yellowRemain = redRemain / unitOfYellowChips;

    numberOfChips[0].amount = numberOfBlackChip;
    numberOfChips[1].amount = numberOfGreenChip;
    numberOfChips[2].amount = numberOfBlueChip;
    numberOfChips[3].amount = numberOfRedChip;
    numberOfChips[4].amount = yellowRemain;

    return numberOfChips;
  };

  const FACTOR = 100;
  const numberOfChips = getNumberOfChips(chipAmount * FACTOR);

  const getChipAmountClass = (amount: number): number => {
    const chipGroupSystem = [
      {color: ChipColor.BLACK, lowerLimit: 21},
      {color: ChipColor.GREEN, lowerLimit: 11},
      {color: ChipColor.BLUE, lowerLimit: 6},
      {color: ChipColor.RED, lowerLimit: 3},
      {color: ChipColor.YELLOW, lowerLimit: 0},
    ];

    if (amount >= chipGroupSystem[4].lowerLimit && amount < chipGroupSystem[3].lowerLimit) {
      return 4;
    }
    if (amount >= chipGroupSystem[3].lowerLimit && amount < chipGroupSystem[2].lowerLimit) {
      return 3;
    }
    if (amount >= chipGroupSystem[2].lowerLimit && amount < chipGroupSystem[1].lowerLimit) {
      return 2;
    }
    if (amount >= chipGroupSystem[1].lowerLimit && amount < chipGroupSystem[0].lowerLimit) {
      return 1;
    }
    if (amount >= chipGroupSystem[0].lowerLimit) {
      return 0;
    }
    return 0;
  };

  const renderChip = (): JSX.Element => {
    // if (!chipAmount) return null;
    // TODO @@ handle chipAmount === 0
    if (!chipAmount || chipAmount === 0) return null;
    // TODO @@ chips
    const index = getChipAmountClass(chipAmount);
    // return (
    //   <img
    //     className={classes.chip}
    //     src={numberOfChips[index].imgPath}
    //     alt={`${numberOfChips[index].color}Chip`}
    //   />
    // );

    return (
      <section className={classes.chipsContainer}>
        {numberOfChips.map((chips, id) => (
          <motion.div
            key={`${chips}_${id}_${chipAmount}`}
            className={classes.chipColumn}
            // can add y if needed
            initial={{opacity: 0, y: 0}}
            animate={{opacity: 1, y: 0}}
            // can add y if needed
            exit={{opacity: 0, y: 0}}
            // TODO @@ chips
            transition={{duration: CHIP_FADING_DURATION / 1000}}
          >
            {Array(Math.round(chips.amount)).fill(
              <img className={classes.chip} src={chips.imgPath} alt={`${chips.color}Chip`} />
            )}
          </motion.div>
        ))}
        {/* {numberOfChips.map((chips, id) => (
          <div key={`${chips}_${id}`} className={classes.chipColumn}>
            {Array(Math.round(chips.amount)).fill(
              // eslint-disable-next-line @next/next/no-img-element
              <img
                // style={{marginBottom: id === 0 ? 0 : -16}}
                style={{marginBottom: -16}}
                className={classes.chip}
                src={chips.imgPath}
                alt={`${chips.color}Chip`}
              />
              // <img className={classes.chip} src={chips.imgPath} alt={`${chips.color}Chip`} />
            )}
          </div>
        ))} */}
      </section>
    );
  };

  return renderChip();
};

export default ChipsImage;
